"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withEventing = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var uuid_1 = require("uuid");
var decoratedBackend_1 = require("../decoratedBackend");
var execution_1 = require("../decoratedBackend/execution");
var WithExecutionEventing = /** @class */ (function (_super) {
    tslib_1.__extends(WithExecutionEventing, _super);
    function WithExecutionEventing(decorated, callbacks) {
        var _this = _super.call(this, decorated) || this;
        _this.callbacks = callbacks;
        _this.execute = function () {
            var _a = _this.callbacks, beforeExecute = _a.beforeExecute, successfulExecute = _a.successfulExecute, failedExecute = _a.failedExecute;
            var executionId = uuid_1.v4();
            beforeExecute === null || beforeExecute === void 0 ? void 0 : beforeExecute(_this.definition, executionId);
            return _super.prototype.execute.call(_this)
                .then(function (result) {
                successfulExecute === null || successfulExecute === void 0 ? void 0 : successfulExecute(result, executionId);
                return new WithExecutionResultEventing(result, _this.createNew, _this.callbacks, executionId);
            })
                .catch(function (error) {
                failedExecute === null || failedExecute === void 0 ? void 0 : failedExecute(error, executionId);
                throw error;
            });
        };
        _this.createNew = function (decorated) {
            return new WithExecutionEventing(decorated, _this.callbacks);
        };
        return _this;
    }
    return WithExecutionEventing;
}(execution_1.DecoratedPreparedExecution));
var WithExecutionResultEventing = /** @class */ (function (_super) {
    tslib_1.__extends(WithExecutionResultEventing, _super);
    function WithExecutionResultEventing(decorated, wrapper, callbacks, executionId) {
        var _this = _super.call(this, decorated, wrapper) || this;
        _this.callbacks = callbacks;
        _this.executionId = executionId;
        _this.readAll = function () {
            var _a = _this.callbacks, successfulResultReadAll = _a.successfulResultReadAll, failedResultReadAll = _a.failedResultReadAll;
            var promisedDataView = _super.prototype.readAll.call(_this);
            return promisedDataView
                .then(function (res) {
                successfulResultReadAll === null || successfulResultReadAll === void 0 ? void 0 : successfulResultReadAll(res, _this.executionId);
                return res;
            })
                .catch(function (e) {
                failedResultReadAll === null || failedResultReadAll === void 0 ? void 0 : failedResultReadAll(e, _this.executionId);
                throw e;
            });
        };
        _this.readWindow = function (offset, size) {
            var _a = _this.callbacks, successfulResultReadWindow = _a.successfulResultReadWindow, failedResultReadWindow = _a.failedResultReadWindow;
            var promisedDataView = _super.prototype.readWindow.call(_this, offset, size);
            return promisedDataView
                .then(function (res) {
                successfulResultReadWindow === null || successfulResultReadWindow === void 0 ? void 0 : successfulResultReadWindow(offset, size, res, _this.executionId);
                return res;
            })
                .catch(function (e) {
                failedResultReadWindow === null || failedResultReadWindow === void 0 ? void 0 : failedResultReadWindow(offset, size, e, _this.executionId);
                throw e;
            });
        };
        return _this;
    }
    return WithExecutionResultEventing;
}(execution_1.DecoratedExecutionResult));
/**
 * This implementation of analytical backend decorates another implementation with support for eventing. Events
 * for significant actions are emitted to defined callback functions (event handlers).
 *
 * @param realBackend - backend supplying the actual implementation of SPI
 * @param callbacks - callbacks to event handlers
 * @beta
 */
function withEventing(realBackend, callbacks) {
    if (isEmpty_1.default(callbacks)) {
        return realBackend;
    }
    return decoratedBackend_1.decoratedBackend(realBackend, {
        execution: function (original) {
            return new execution_1.DecoratedExecutionFactory(original, function (execution) { return new WithExecutionEventing(execution, callbacks); });
        },
    });
}
exports.withEventing = withEventing;
//# sourceMappingURL=index.js.map